import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Skeleton} from '@chakra-ui/react'
import CmsContent from '../../components/cms-content'
import useIntersectionObserver from '../../hooks/use-intersection-observer'

/**
 * Lazily display cms html content
 * @param {string} children - the html content to display in the widget
 * @param {'eager'|'lazy'} loading - Lazy load the widget or render it immediately
 */
const WidgetCms = ({children, loading = 'lazy'}) => {
    // flag that indicates if the widget was displayed to trigger loading of data
    const [setRef, wasDisplayed] = useIntersectionObserver({
        useOnce: true,
        initialInView: loading === 'eager',
        skip: loading === 'eager'
    })
    // memoize the skeleton and cms props to reduce re-renders
    const {skeletonProps, cmsProps} = useMemo(
        () => ({
            skeletonProps: {
                dangerouslySetInnerHTML: {__html: children},
                // fix for cms that depends on js to measure screen size and resize like sk-slider
                // and before that it overflows the body
                overflowX: 'hidden'
            },
            cmsProps: {content: {c_body: children}}
        }),
        [children]
    )
    // if the widget was not displayed, show a skeleton
    if (!wasDisplayed) {
        return <Skeleton ref={setRef} {...skeletonProps} />
    }
    return <CmsContent {...cmsProps} />
}

WidgetCms.propTypes = {
    children: PropTypes.string,
    loading: PropTypes.oneOf(['lazy', 'eager'])
}

export default WidgetCms
